import { render, staticRenderFns } from "./yuelist.vue?vue&type=template&id=0d8c299a&scoped=true"
import script from "./yuelist.vue?vue&type=script&lang=js"
export * from "./yuelist.vue?vue&type=script&lang=js"
import style0 from "./yuelist.vue?vue&type=style&index=0&id=0d8c299a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c299a",
  null
  
)

export default component.exports